import React from 'react'
import { Intro as IntroType } from '../../../types/end-journey'

interface IntroProps {
  intro: IntroType
  onStart: () => void
}

export const Intro: React.FC<IntroProps> = ({ intro, onStart }) => {
  const contentLines = intro.content.split('\n')

  return (
    <div className="w-full max-w-2xl mx-auto px-4 sm:px-6 pt-8 sm:pt-16 pb-12 sm:pb-20">
      <div className="space-y-4 sm:space-y-10">
        <h1 className="text-2xl sm:text-[32px] font-semibold text-gray-900 text-center">
          {intro.title}
        </h1>
        <div className="space-y-3 sm:space-y-4">
          {contentLines.map((paragraph, index) => (
            <p
              key={index}
              className="text-gray-600 text-sm sm:text-base leading-relaxed text-center md:text-left"
            >
              {paragraph}
            </p>
          ))}
        </div>
      </div>
      <button
        onClick={onStart}
        className="mt-6 sm:mt-20 w-full mx-auto px-4 py-2 sm:py-3 bg-[#E85A2D] text-white rounded-full font-medium text-sm sm:text-base hover:bg-[#D54D23] transition-colors block"
      >
        Start
      </button>
    </div>
  )
}
